import React from 'react';
import { Box } from '@material-ui/core';
import { OrderLine } from '../../../../server-types';
import { usePriceService } from '../../../../utils/hooks/priceService';
import { Typography } from '../../../../ui-kit';
import { DetailsRowContainer, ItemsCount } from './style';

const DetailsRow = ({ product, quantity }: OrderLine) => {
    const { priceService } = usePriceService();
    const productPrice = priceService.toLocaleString(product.priceSell);
    return (
        <DetailsRowContainer justifyContent='space-between'>
            <Typography variant='h6'>
                {product.name}
            </Typography>
            <Box display='flex' alignItems='center'>
                <Typography>
                    {productPrice}
                </Typography>
                <ItemsCount ml={1.5} count={quantity} />
            </Box>
        </DetailsRowContainer>
    );
};

export default DetailsRow;
